import initialState from "../../store/initialState";

const reportsPaymentInitialState = {
	...initialState,
	paymentsEmployer: [],
	paymentsEmployees: {}
};

export default reportsPaymentInitialState;
